//@ts-nocheck
import { Navigate, Outlet, redirect } from 'react-router-dom';
import AuthService from '../services/AuthService';

type Props = {
children: any
requiredPrevileges: any
}

const AuthorizedRoute = ({
    children,
    requiredPrevileges
}): Props => {
    try {
        console.log("Can access Authorized route", AuthService.hasRequiredPrevileges(requiredPrevileges), requiredPrevileges, AuthService.getPrivileges())
        if (!AuthService.hasRequiredPrevileges(requiredPrevileges)) {
            let redirectPath = '/login'
            if (AuthService.isLoggedIn()) {
                redirectPath = AuthService.getLandingRoute()
            }
            redirect(redirectPath)
            return null
        }
        return children ? children : <Outlet />;

    } catch (error) {
        return <Navigate to={"/login"} replace />;
    }
};

export default AuthorizedRoute;